import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header  from "./Header";
import Footer from "./Footer";

function ProductDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { product } = location.state || {}; // get product from navigation state

  if (!product) {
    return <div style={{ padding: 20 }}>No product selected</div>;
  }

  return (
    <>
    <Header/>
    <div className="product-details-container" style={{ padding: "20px" }}>
      

      {/* Left-Right Section */}
      <div
        className="details-section"
        style={{
          display: "flex",
          gap: "20px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        {/* Left - Description */}
        <div style={{ flex: 1, minWidth: "250px" }}>
          <h2>{product.title}</h2>
          <p>{product.description}</p>

          <ul
            style={{
              paddingLeft: "20px", // shift bullets slightly left
              marginTop: "10px",
            }}
          >
            {product.details.points.map((point, index) => (
              <li
                key={index}
                style={{
                  marginBottom: "8px",
                  listStylePosition: "inside", // bullet aligns with text
                }}
              >
                {point}
              </li>
            ))}
          </ul>
        </div>

        {/* Right - Image */}
        <div style={{ flex: 1, minWidth: "250px" }}>
          <img
            src={product.image}
            alt={product.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </div>
      </div>

      {/* Table */}
      <table
        border="1"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0" }}>
            <th style={{ padding: "8px", textAlign: "left" }}>Property</th>
            <th style={{ padding: "8px", textAlign: "left" }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {product.details.table.map((row, index) => (
            <tr key={index}>
              <td style={{ padding: "8px" }}>{row.property}</td>
              <td style={{ padding: "8px" }}>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <Footer/>
    </>
  );
}

export default ProductDetails;
